import fCore 								from 'foundation-sites/dist/js/plugins/foundation.core.js';
import fInterchange 			 	from 'foundation-sites/dist/js/plugins/foundation.interchange.js';
import fReveal 							from 'foundation-sites/dist/js/plugins/foundation.reveal.js';
import fMediaQuery 					from 'foundation-sites/dist/js/plugins/foundation.util.mediaQuery.js';
import fTimerAndImageLoader from 'foundation-sites/dist/js/plugins/foundation.util.timerAndImageLoader.js';
import fBox 								from 'foundation-sites/dist/js/plugins/foundation.util.box.js';
import fTrigger 					  from 'foundation-sites/dist/js/plugins/foundation.util.triggers.js';
import fKeyboard					  from 'foundation-sites/dist/js/plugins/foundation.util.keyboard.js';
import fMotion 					    from 'foundation-sites/dist/js/plugins/foundation.util.motion.js';
// import fEqualizer 					from 'foundation-sites/dist/js/plugins/foundation.equalizer.js';

class FoundationInit {

	constructor(){
		this._init();
	}

 _init(){
    
	  document.addEventListener('DOMContentLoaded', (event) => {
	    jQuery(document).foundation();
	  });
	}

}

export const foundationInit = new FoundationInit();
